import { AssetMaintenanceScheduleDto } from "data/dtos/AssetMaintenanceScheduleDto";
import { WorkawareBaseClass } from "./WorkawareBaseClass";
import { AssetCheckinDto, AssetDocumentDto, AssetMaintenanceDto, AssetPhotoDto } from "data/dtos";

export class AssetModel extends WorkawareBaseClass {
    _className = 'AssetModel'
    public Id: number
    public Name: string
    public CompanyId: number
    public Description: string
    public IsActive: boolean
    public ParentAssetId?: number
    public CreatedByUserId: number
    public CreatedOn?: Date
    public AssetCategoryId?: number
    public Code: string
    public Make: string
    public Model: string
    public SerialNumber: string
    public Barcode: string
    public PhotoUrl: string
    public Odometer?: number
    public OdometerUnitId?: number
    public Price?: number
    public Location: string
    public BarcodeTypeId?: number
    public MachineHours?: number
    public AssignedOperator: string
    public PrimaryPhotoId?: number
    public CMMSAssetMaintenanceSchedules: Array<AssetMaintenanceScheduleDto> = []
    public CMMSPhotos: Array<AssetPhotoDto> = []
    public CMMSMaintenances: Array<AssetMaintenanceDto> = []
    public CMMSDocuments: Array<AssetDocumentDto> = []
    public CMMSCheckins: Array<AssetCheckinDto> = []
}